import { colorPalette } from "../../utils/constants";

export const customStyles = {
  coverImageContainer: {
    mt: 15,
    position: "relative" as const,
    width: "100%",
    height: "400px",
    overflow: "hidden",
  },
  coverImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover" as const,
    objectPosition: "center center" as const,
    opacity: 0.5,
  },
  coverOverlay: {
    position: "absolute" as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  coverTitle: {
    color: colorPalette.white,
    fontFamily: "'Bebas Neue', sans-serif",
    textAlign: "center" as const,
    textTransform: "uppercase" as const,
    letterSpacing: "2px",
    padding: "0 20px",
  },
};
